import axios from 'axios'
import store from '@/store'

const actions = {
  async upload (_, { file, path }) {
    if (!file) {
      throw new Error('Arquivo não informado')
    }

    const formData = new FormData()
    formData.append('file', file)
    formData.append('path', path)

    const companyId = store.get('authStore@currentCompany')?.id
    const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/files/upload?companyId=${companyId}`, formData)

    return data
  },

  async get (_, { path }) {
    if (!path) {
      throw new Error('Path não informado')
    }

    const companyId = store.get('authStore@currentCompany')?.id
    const url = `${process.env.VUE_APP_API_URL}/files?companyId=${companyId}&path=${encodeURIComponent(path)}`
    const { data } = await axios.get(url)

    return data.signedUrl || data.signed_url || data.url || data
  },

  async remove (_, { path }) {
    if (!path) {
      throw new Error('Path não informado')
    }

    const companyId = store.get('authStore@currentCompany')?.id

    await axios.delete(`${process.env.VUE_APP_API_URL}/files?companyId=${companyId}`, {
      data: { path },
    })
  },
}

export default {
  namespaced: true,
  actions,
}
